import React, { useContext, useState } from "react";
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, 
    MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBContainer, MDBIcon
} from "mdbreact";
import { Link } from 'react-router-dom';

import HeaderLoggedIn from "./HeaderLoggedIn";
import HeaderLoggedOut from './HeaderLoggedOut'
import StateContext from '../../StateContext'
import DispatchContext from "../../DispatchContext";

function NavbarPage(props) {

    const [isOpen, setIsOpen] = useState(false)
    const appState = useContext(StateContext)
    const appDispatch = useContext(DispatchContext);
    

    const headerContent = appState.loggedIn ? <HeaderLoggedIn setIsOpen={setIsOpen} /> : <HeaderLoggedOut />

    const toggleCollapse = () => {
        if (isOpen) {
            setIsOpen(false)
        } else {
            setIsOpen(true)
        }
    }


  return (
    
      <MDBNavbar className="bg-primary" dark expand="md">
          <MDBContainer>
            <MDBNavbarBrand>     
                <Link to="/">
                    <img src="https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/players%2Fdefault-logo-team.jpg?alt=media&token=a531ec2d-3fbd-4068-8130-ed701b28548c" className="img-fluid rounded-circle" style={{maxWidth: "35px"}} alt="Site logo"/>
                </Link>
            </MDBNavbarBrand>
            <MDBNavbarToggler onClick={toggleCollapse} />
            <MDBCollapse id="navbarCollapse3" isOpen={isOpen} navbar>
            <MDBNavbarNav left>
                <MDBNavItem onClick={toggleCollapse} className={appState.currentPage === "latest-news" ? "active" : ""}>
                    <MDBNavLink to="/innlegg/1" onClick={() => appDispatch({type: "currentPage", value: "latest-news"})}>Latest news</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem onClick={toggleCollapse} className={appState.currentPage === "leagues" ? "active" : ""}>
                    <MDBNavLink to="/football-api" onClick={() => appDispatch({type: "currentPage", value: "leagues"})}>Leagues</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem onClick={toggleCollapse} className={appState.currentPage === "live" ? "active" : ""}>
                    <MDBNavLink to="/live-fixtures/592160" onClick={() => appDispatch({type: "currentPage", value: "live"})}><i className="far fa-compass"></i> Livesenter</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem onClick={toggleCollapse} className={appState.currentPage === "teams" ? "active" : ""}>
                    <MDBNavLink to="/teams" onClick={() => appDispatch({type: "currentPage", value: "teams"})}>Teams</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                    <MDBDropdown>
                        <MDBDropdownToggle nav caret>
                            <span className="mr-2">Sider</span>
                        </MDBDropdownToggle>
                        <MDBDropdownMenu>
                            <MDBDropdownItem><Link to="/media">Galleri</Link></MDBDropdownItem>
                            <MDBDropdownItem>
                                <Link to="/quiz">
                                    Quiz
                                </Link>
                            </MDBDropdownItem>
                            <MDBDropdownItem>
                                <Link to="/transfers">
                                    Overganger
                                </Link>
                            </MDBDropdownItem>
                            <MDBDropdownItem>
                                <Link to="/utenlandsproffer">
                                    Utenlandsproffer
                                </Link>  
                            </MDBDropdownItem>
                            <MDBDropdownItem>
                                <Link to="/football-manager">
                                    Football Manager
                                </Link>  
                            </MDBDropdownItem>
                        </MDBDropdownMenu>
                    </MDBDropdown>
                </MDBNavItem>

            </MDBNavbarNav>

            {!props.staticEmpty ? headerContent : ""}

            </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>
    );
  }


export default NavbarPage;